<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Tabelas de Preço', 'link' : '/tableprice' }]"
    />

    <h1 class="text-center" v-if="operation === 'store'">Nova Tabela de Preço</h1>
    <h1 class="text-center" v-if="operation === 'update'">Atualizar Tabela de Preço</h1>
    <!-- Div Formulario -->
    <form class="row" v-if="!loading" @submit.prevent="actionOperation" @keydown.enter.prevent>
      <div class="col-2"></div>
      <div class="col-8" >
        <div class="row m-0 p-0 mb-3">
          <div class="col-12">
            <div class="mt-2" :class="['field', { 'field--error': errors.name }]">
              <label for="inpName" class="field__label field__label--required">Nome</label>
              <input id="inpName" placeholder="Nome da tabela de preço" class="field__input" type="text" v-model="dados.name" />
              <span v-if="errors.name" class="field__feedback field__feedback--error">
                <svg class="field__feedback-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                {{ errors.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <!-- ===== ITENS ===== -->
            <h5 class="text-center mb-3">Itens:</h5>

            <div v-for="item in dados.listaitens" :key="item.id" class="col-6 col-md-3 p-1">
              <div class="rental-item-card">
                <img :src="item.foto_url" class="rental-item-img" alt="" />
                <div class="rental-item-body">
                  <p class="rental-item-name">{{ item.name }}</p>
                  <div class="rental-item-qty-row">
                    <input
                      type="number"
                      step="0.01"
                      v-model="item.price"
                      class="rental-qty-input"
                      :name="'priceItem-'+item.id"
                      :id="'priceItem-'+item.id"
                    />
                  </div>
                  <div class="rental-item-meta">
                    <span class="rental-item-meta__label">Preço padrão</span>
                    <span class="rental-item-meta__value">R$ {{ item.unit_price }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 col-md-3 p-1" @click="openModal('modal_addItem')">
              <div class="rental-item-card rental-item-card--add">
                <div class="rental-item-card--add-icon">+</div>
                <span class="rental-item-card--add-label">Adicionar Item</span>
              </div>
            </div>
        </div>
      </div>
      
      <div class="col-2"></div>
      <!-- Div Botão Salvar -->
      <div class="row mt-4 text-center">
        <div class="col-12">
          <router-link class="btn btn-secondary me-2" to="/tableprice">
            Voltar
          </router-link>
          <button type="submit" class="btn btn-primary me-2">
            <span>{{ operation === 'store' ? 'Salvar' : 'Atualizar' }}</span>
          </button>
          <button type="button" @click="clearForm()" class="btn btn-secondary me-2">
            Limpar
          </button>
        </div>
      </div>
      <div style="height: 40px;"></div>
    </form>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3 text-center">
      <div>
        <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" v-if="operation === 'update' && loading">Carregando dados do cliente...</p>
        <p class="mt-2" v-else-if="loading">Salvando cliente...</p>
      </div>
    </div>

    <!-- Modal Adicionar Itens -->
    <div class="modal fade" id="modal_addItem" tabindex="-1" aria-labelledby="modalAddItemLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAddItemLabel">Adicionar item</h5>
            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="modal-items-grid">
              <div
                v-for="item in listaitens"
                :key="item.id"
                class="modal-item-card"
                @click="select_item(item)"
              >
                <img :src="item.foto_url" class="modal-item-card__img" alt="" />
                <div class="modal-item-card__body">
                  <p class="modal-item-card__name">{{ item.name }}</p>
                  <span class="modal-item-card__price">R$ {{ parseFloat(item.unit_price).toFixed(2) }}</span>
                </div>
                <div class="modal-item-card__add">+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import { tableprice } from '@/models/tableprice';
import { itens } from '@/models/itens';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import router from '@/router';
import { Modal } from "bootstrap";

export default {
  name: "NewClientView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const toastStore = useToastStore();
    var loading = ref(false);
    var operation = ref('store');
    const model = tableprice();
    const modelitens = itens();
    var modal = null;
    let listaitens = ref([]);

    async function loadItens() {
      listaitens.value = await modelitens.list();
    }

    const errors = reactive({
      name: false,
      itens: false,
      valores: false
    });

    const dados = reactive({
      listaitens: [],
      name: null,
      id: null
    });

    function clearForm() {
      dados.name = null;
      dados.listaitens = [];
      errors.name = false;
    }

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    onMounted(() => {
      const query = window.location.search;
      const urlParams = new URLSearchParams(query);
      const edit = urlParams.get('edit');
      const id = urlParams.get('id');
      loadItens();

      if (edit && id) {
        document.title = "Atualizar Tabela de Preço - AlugUp";

        operation.value = 'update';
        loading.value = true;
        model.getOne(id).then((response) => {
          dados.name = response.name;
          dados.id = response.id;
          dados.listaitens = response.items.map(obj => {
            return {
              id: obj.item.id,
              name: obj.item.name,
              foto_url: obj.item.foto_url,
              valor_locacao: obj.item.unit_price,
              price: obj.price
            }
          });
          loading.value = false;
        }).catch((error) => {
          toastStore.error('Erro ao carregar cliente: ' + parseError(error));
          loading.value = false;
        });
      }
    });

    const actionOperation = () => {
      if (operation.value === 'update') {
        update();
      } else {
        if (!dados.name) {
          toastStore.warning('O nome é obrigatório.');
          return;
        }
        store();
      }
    }

    function select_item(item) {
      const existingItem = dados.listaitens.find(obj => obj.id === item.id);
      if (!existingItem) {
        var add = {
          'id' : item.id,
          'foto_url' : item.foto_url,
          'name' : item.name,
          'unit_price' : parseFloat(item.unit_price).toFixed(2),
          'price' : parseFloat(item.price).toFixed(2),
        }
        dados.listaitens.push(add)
        closeModal();
      }
    }

    function store() {
      loading.value = true;
      model.store(dados).then(() => {
        toastStore.success('Tabela de preço cadastrada com sucesso!');
        loading.value = false;
        router.push('/tableprice');
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao cadastrar tabela de preço: ' + parseError(error));
      });
    }

    function update() {
      loading.value = true;
      model.update(dados).then(() => {
        toastStore.success('Tabela de preço atualizada com sucesso!');
        loading.value = false;
        router.push('/tableprice');
      }).catch((error) => {
        toastStore.error('Erro ao atualizar tabela de preço: ' + parseError(error));
        loading.value = false;
      });
    }

    return {
      actionOperation,
      operation,
      loading,
      dados,
      errors,
      openModal,
      closeModal,
      select_item,
      listaitens,
      clearForm
    }

  }
}
</script>

<style scoped>

</style>